import * as Sentry from '@sentry/react';
import { getCurrentUser } from '../services/api';
import { useState, useEffect } from 'react';
import { User } from '../types';

export const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const response = await getCurrentUser();
        setCurrentUser(response);
      } catch (e) {
        Sentry.captureException(e);
        setError('Unable to load your account. Please sign out and try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  return { currentUser, isLoading, error };
};
